import React from 'react'

interface IconProps {
  width?: number
  height?: number
  fill?: string
  stroke?: string
}

const IdDashboard: React.FC<IconProps> = ({
  width = 20,
  height = 20,
  fill = 'none',
  stroke = '#64748B',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
    >
      <g clipPath="url(#clip0_395_3655)">
        <path
          d="M4 4H10V12H4V4Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 16H10V20H4V16Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 12H20V20H14V12Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 4H20V8H14V4Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_3655">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IdDashboard
